export default {
  choose_an_option: 'Wähle eine Option:',
  choose_an_option_is_formal: 'Wählen Sie eine Option:',
  select_options: 'Optionen auswählen',
  select_options_is_formal: 'Wählen Sie die zutreffenden Optionen aus',
  enter_text_here: 'Text hier eingeben',
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  whatsapp: 'WhatsApp',
  sms: 'SMS /iMessage',
  email: 'E-Mail',
  nps_scale_meaning: '0 = unwahrscheinlich / 10 = sehr wahrscheinlich',
  selection: 'Auswahl',
  answer: 'Antwort',
  informal_redirect_counter_message:
    'Ich leite dich in {{counter}} Sekunden auf unsere Webseite weiter',
  formal_redirect_counter_message:
    'Ich leite Sie in {{counter}} Sekunden auf unsere Webseite weiter',
  informal_please_provide_answers_to_both_questions:
    'Bitte beantworte beide Fragen',
  informal_please_answer_the_first_question: 'Bitte beantworte die erste Frage',
  informal_please_answer_the_second_question:
    'Bitte beantworte die zweite Frage',
  informal_answer_at_least_one_question:
    'Bitte beantworte mindestens eine Frage',
  formal_please_provide_answers_to_both_questions:
    'Bitte beantworten Sie beide Fragen',
  formal_please_answer_the_first_question:
    'Bitte beantworten Sie die erste Frage',
  formal_please_answer_the_second_question:
    'Bitte beantworten Sie die zweite Frage',
  formal_answer_at_least_one_question:
    'Bitte beantworten Sie mindestens eine Frage',
  share_api_option_text: 'App auswählen',
  share_status_SHARE: 'Geteilt',
  share_status_CANCEL: 'Teilen abgebrochen',
  language_nav_label: 'Sprachauswahl',
  OPENS_IN_NEW_TAB: 'öffnet in neuem Tab',
  nps_rating_aria: 'Bewertung',
  language_switcher_aria: 'Sprache auswählen',
  company_logo_aria: 'Firmenlogo (öffnet in neuem Tab)',
  powered_by_hypt_aria: 'Powered by HYPT (öffnet in neuem Tab)',
  employee_search_placeholder: 'Suchen...',
  employee_search_aria: 'Mitarbeiter suchen',
  loading_aria: 'Laden',
  chat_messages_aria: 'Chatnachrichten',
  skip_to_content: 'Zum Inhalt springen',
  company_logo_alt: 'Firmenlogo',
  ai_feedback_input_aria: 'Geben Sie Ihr Feedback ein',
  error_funnel_not_published: 'Fragebogen noch nicht veröffentlicht',
  error_funnel_not_found: 'Dieser Fragebogen existiert nicht',
  error_funnel_come_back_later:
    'Bitte kommen Sie später wieder. Wir danken für Ihre Geduld.',
  error_404: 'ERROR 404',
  error_page_not_found: 'SEITE NICHT GEFUNDEN',
  chat_history_aria: 'Chat Verlauf',
  checkbox_required_sr: 'mindestens eine Auswahl erforderlich',
  checkbox_required_sr_is_formal: 'mindestens eine Auswahl erforderlich',
  informal_ai_answer_required_hint: 'Schreib dein Feedback, um fortzufahren',
  formal_ai_answer_required_hint: 'Schreiben Sie Ihr Feedback, um fortzufahren'
};
